import React, { FC } from 'react';
import styled from 'styled-components';
import { up } from 'styled-breakpoints';
import StandardHeader from './StandardHeader';
import FullScreenHeader from './FullScreenHeader';
import { Colors } from '../../system/system-types';
import Spacer from '../Spacer';

interface HeadingProps {
  data: any;
}

type Link = {
  link_type: string;
  url: string;
}

export interface HeaderProps {
  title: Record<string, any>;
  subtitle?: Record<string, any>;
  paragraph?: Record<string, any>;
  desktopImage: Record<string, any>;
  mobileImage?: Record<string, any>;
  buttonColor?: string;
  buttonContent?: string;
  buttonLink?: Link;
  position?: string;
  textColor?: keyof Colors;
} 

const Heading = styled.header`
  padding: 0 1rem;

  ${up('phone')} {
    padding: 0 1.5rem;
  }

  ${up('tablet-portrait')} {
    padding: 0 1.875rem;
  }
`;

const Header: FC<HeadingProps> = ({ data }) => {
  const {
    variant,
    title,
    subtitle,
    paragraph,
    desktop_image,
    mobile_image,
    button_color,
    button_content,
    button_link,
    position,
    text_color
  } = data;

  const variantComponents: Record<string, FC<HeaderProps>> = {
    standard: StandardHeader,
    fullscreen: FullScreenHeader,
  };
  const Component = variantComponents[variant] ?? StandardHeader;
  
  return (
    <>
      <Heading>
        <Component
          title={title}
          subtitle={subtitle}
          desktopImage={desktop_image}
          mobileImage={mobile_image}
          buttonColor={button_color}
          buttonContent={button_content}
          buttonLink={button_link}
          paragraph={paragraph}
          position={position}
          textColor={text_color}
        />
      </Heading>
      <Spacer spacing={['md3']} />
    </>
  )
};


export default Header;
